require.register("common/documentinfo", function(exports, require, module){
  $0
  
});

